const baseDefaults = {
  '0005': true,
  '0010': true,
  '0015': true,
  '0020': true,
  '0021': false,
  '0025': true,
  '0028': false,
  '0030': true,
  '0035': true,
  '0040': true,
  '0042': true,
  '0044': true,
  '0045': true,
  '0050': false,
  '0051': false,
  '0060': false,
  '0061': false,
  '0062': false,
  '0063': false,
  '0064': false,
  '0066': false,
  '0067': false,
  '0071': true,
  '0075': true,
  '0080': true,
  '0081': false,
  '0085': false,
  '0087': true,
  '0095': false
}
const frDefaults = {
  ...baseDefaults,
  '0030': false,
  '0071': false,
  '0075': false,
  '0087': false
}
const deDefaults = {
  ...baseDefaults,
  '0071': false,
  '0075': false,
  '0080': false,
  '0087': false
}
const nordDefaults = {
  ...baseDefaults,
  '0030': false,
  '0071': false,
  '0075': false,
  '0080': false,
  '0087': false
}

const allowedCategoriesData = {
  bk: {
    de: deDefaults,
    da: nordDefaults,
    fi: nordDefaults,
    no: nordDefaults,
    sv: nordDefaults
  },
  hp: {
    fr: frDefaults,
    it: baseDefaults,
    da: nordDefaults,
    fi: nordDefaults,
    no: nordDefaults,
    sv: nordDefaults
  },
  id: {
    fr: frDefaults,
    it: baseDefaults,
    da: nordDefaults,
    fi: nordDefaults,
    no: nordDefaults,
    sv: nordDefaults
  },
  wp: {
    fr: frDefaults,
    it: baseDefaults,
    da: nordDefaults,
    fi: nordDefaults,
    no: nordDefaults,
    sv: nordDefaults
  }
}

export { allowedCategoriesData }
